/* eslint-disable global-require,import/no-unresolved, react/forbid-prop-types, react/no-array-index-key, react/jsx-no-bind, react/no-string-refs */
import React from 'react'
import PropTypes from 'prop-types'
import {
 Dimensions, ScrollView, Text, TouchableOpacity, View,
} from 'react-native'
import Image from 'react-native-scalable-image'
import styles, { colors } from '../../styles'
import textStyles from '../../styles/text'
import buttonStyles from '../../styles/button'
import * as ResourceManager from '../methods/ResourceManager'
import * as NavigationRefHelpers from '../../navigators/NavigationRefHelpers'

const setupButtonStyles = {
 communicatorSetupButtonLeft: {
    alignItems: 'center',
    borderRadius: 3,
    flex: 1,
    justifyContent: 'center',
    marginBottom: 8,
    marginLeft: 16,
    minHeight: 44,
  },
  communicatorSetupButtonRight: {
    alignItems: 'center',
    borderRadius: 3,
    flex: 1,
    justifyContent: 'center',
    marginBottom: 8,
    marginLeft: 16,
    marginRight: 16,
    minHeight: 44,
    backgroundColor: colors.bscBlue,
  },
}

class CommunicatorSetupStep extends React.Component {
  onLayout(e) {
    const { nativeEvent: { layout: { height } } } = e
    // eslint-disable-next-line react/no-unused-class-component-methods
    this.height = height
    this.forceUpdate()
  }

  generateButtons() {
    const {
      nextTapped, finishTapped, trackEventAndPop, t, initRouteName, testID,
    } = this.props
    return (
      <View style={styles.footer}>
        <TouchableOpacity
          testID={`btm-back-btn-${testID}`}
          accessibilityLabel={t('access:backButton')}
          onPress={() => {
            if (window.ReactNativeWebView && NavigationRefHelpers.isRoot()) {
              window.ReactNativeWebView.postMessage('pop')
            } else {
              trackEventAndPop('back')
            }
          }}
          style={[setupButtonStyles.communicatorSetupButtonLeft]}
        >
          <Text
            maxFontSizeMultiplier={1.5}
            style={[buttonStyles.buttonText, { color: colors.bscBlue }]}
          >
            {t('common:backButton')}
          </Text>
        </TouchableOpacity>
        <TouchableOpacity
          accessibilityLabel={nextTapped ? t('access:nextButton') : t('access:finishButton')}
          testID={nextTapped ? `next-btn-${testID}` : 'finish-btn'}
          onPress={nextTapped || (() => finishTapped(initRouteName))}
          style={[setupButtonStyles.communicatorSetupButtonRight]}
        >
          <Text
            maxFontSizeMultiplier={1.5}
            style={[buttonStyles.buttonText, styles.white]}
          >
            {nextTapped ? t('common:nextButton') : t('common:finishButton')}
          </Text>
        </TouchableOpacity>
      </View>
    )
  }

  render() {
    const {
      title, setupImage, testID, stepsImage, heading, paragraphs, children, accessibilityLabel,
    } = this.props
    return (
      <View style={{ flex: 1 }}>
        <ScrollView
          onLayout={this.onLayout.bind(this)}
          style={{
            backgroundColor: colors.white,
            flex: 1,
          }}
          contentContainerStyle={{ flexGrow: 1, flexDirection: 'column', paddingBottom: 10 }}
          testID={`scrollview-${testID}`}
          accessibilityLabel={accessibilityLabel}
        >
          <View style={styles.stepsContainer}>
            <Text testID={`heading-${testID}`} style={[textStyles.h1, styles.shark_grey]}>{heading}</Text>
            <Image
              width={Dimensions.get('window').width - 33}
              style={styles.setupStepNumber}
              source={{ uri: ResourceManager.loadImage(stepsImage) }}
            />
          </View>
          <View style={{ flexGrow: 1, padding: 16 }}>
            <Text testID={`title-${testID}`} style={[textStyles.h2, styles.shark_grey]}>
              {title}
            </Text>
            {setupImage ? (
              <View style={[{
                paddingTop: 10,
                paddingBottom: 10,
                width: Dimensions.get('window').width - 32,
              }]}
              >
                <Image
                  width={Dimensions.get('window').width - 32}
                  source={{ uri: ResourceManager.loadImage(setupImage) }}
                />
              </View>
            ) : children}
            {
              paragraphs.map((paragraph, index) => (<View testID={`paragraph-${index}-${testID}`} key={index}>{paragraph}</View>))
            }
          </View>
          {this.generateButtons()}
        </ScrollView>
      </View>
    )
  }
}

CommunicatorSetupStep.propTypes = {
  accessibilityLabel: PropTypes.string.isRequired,
  stepsImage: PropTypes.string.isRequired,
  setupImage: PropTypes.string,
  heading: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  testID: PropTypes.string.isRequired,
  paragraphs: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired,
  initRouteName: PropTypes.string,
  nextTapped: PropTypes.func,
  finishTapped: PropTypes.func,
  children: PropTypes.instanceOf(Object),
  trackEventAndPop: PropTypes.func.isRequired,
}

CommunicatorSetupStep.defaultProps = {
  nextTapped: null,
  finishTapped: null,
  initRouteName: null,
  setupImage: null,
  children: null,
}

export default CommunicatorSetupStep
